export default {
    active_sessions: "Белсенді сессиялар",
    ask_for_details_on_response: "Жауап беру кезінде деректерді сұрау",
    browser: "Браузер",
    browser_data: "Браузер деректері",
    current_session: "Ағымдағы сессия",
    delete_all_sessions_except_current: "Ағымдағыдан басқа, барлық сессияларды жою",
    delete_attachment: "Кірістемені жою",
    delete_signed: "Қол қойылғанды жою",
    failed_login_attempts: "Сәтсіз кіру әрекеттері",
    finished_sessions: "Аяқталған сессиялар",
    last_use: "Соңғы пайдалану",
    login_attempt: "Кіру әрекеті",
    operating_system: "Операциялық жүйе",
    password_expires_in_days: "Құпия сөзіңіздің мерзімі бүгін аяқталады | Құпия сөзіңіздің мерзімі {day} күннен кейін аяқталады | Құпия сөзіңіздің мерзімі {day} күннен кейін аяқталады",
    password_valid_until_note: "Ағымдағы құпия сөздің жарамдылық мерзімі:",
    question_for_women_only: "Сұрақ тек әйелдер үшін",
    reset_questionnaire_fill: "Сауалнаманы толтыруды қалпына келтіру",
    sessions: "Сессиялар",
    tell_more: "Толығырақ айтыңыз",
    wrong_password: "Қате құпия сөз",
    "2fa_failed": "Екі факторлы аутентификация қатесі"
}

